import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _579e8ef8 = () => interopDefault(import('../pages/attendance/index.vue' /* webpackChunkName: "pages/attendance/index" */))
const _735f79bf = () => interopDefault(import('../pages/holiday/index.vue' /* webpackChunkName: "pages/holiday/index" */))
const _8bcb4724 = () => interopDefault(import('../pages/home/index.vue' /* webpackChunkName: "pages/home/index" */))
const _60b029d0 = () => interopDefault(import('../pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _17b1ccfa = () => interopDefault(import('../pages/report/index.vue' /* webpackChunkName: "pages/report/index" */))
const _b113b294 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/attendance",
    component: _579e8ef8,
    name: "attendance"
  }, {
    path: "/holiday",
    component: _735f79bf,
    name: "holiday"
  }, {
    path: "/home",
    component: _8bcb4724,
    name: "home"
  }, {
    path: "/profile",
    component: _60b029d0,
    name: "profile"
  }, {
    path: "/report",
    component: _17b1ccfa,
    name: "report"
  }, {
    path: "/",
    component: _b113b294,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
